<template>
  <CardWithTitle
    :item-id="itemId"
    :request-status="requestStatus"
    :options-data="cardOptionsWithCSVExportOption"
    @call-option-menu="callOptionMenu"
    @reload="$emit('reload', $event)"
  >
    <v-row
      no-gutters
      class="multibar-chart-container fill-height"
      justify="center"
    >
      <HighCharts
        v-if="series.length"
        :ref="chartRef"
        :key="itemId"
        class="multibar-chart"
        :options="chartOptions"
      />
      <template v-else>
        <p
          v-if="requestStatus === 'success'"
        >
          {{ $t('components.models.BubbleChart.status.success') }}
        </p>
        <p
          v-else-if="requestStatus === 'error'"
        >
          {{ $t('components.models.BubbleChart.status.error') }}
        </p>
      </template>
    </v-row>
    <template #top-right-slot />
  </CardWithTitle>
</template>

<script>
import { Chart } from 'highcharts-vue';
import highChartsBasics from '@/mixins/highcharts-basics';
import exportModel from '@/mixins/export-model';
import cardsModel from '@/mixins/cards-model';
import merge from 'lodash/merge';
import CardWithTitle from '@/components/cards/models/CardWithTitle';

export default {
  name: 'BubbleChart',
  components: {
    HighCharts: Chart,
    CardWithTitle,
  },
  mixins: [
    highChartsBasics,
    exportModel,
    cardsModel,
  ],
  props: {
    requestStatus: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    series: {
      type: [Array, Object],
      default: () => ([]),
    },
    categories: {
      type: [Array, Object],
      default: () => ([]),
    },
    cardOptions: {
      type: [Array, Object],
      default: () => ([]),
    },
  },
  computed: {
    chartOptions() {
      const customOptions = {
        chart: {
          plotBorderWidth: 0,
          type: 'bubble',
        },
        legend: {
          enabled: true,
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              format: '{point.name}',
            },
            stickyTracking: false,
          },
          bubble: {
            minSize: 20,
          },
        },
        series: this.series,
        subtitle: {
          text: '',
        },
        title: {
          text: '',
        },
      };
      return merge({}, this.highchartsBasics, this.highchartTheme, customOptions, this.cardOptions);
    },
  },
};
</script>

<style scoped lang="scss">
  .multibar-chart {
    width: 100%;
  }
</style>
